import { useNavigate } from 'react-router-dom';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';
import { Bell, MagnifyingGlass, Sparkle, List } from '@phosphor-icons/react';
import { api } from '../../lib/api';
import { HelpButton } from '../HelpButton';

export const TopBar = ({ t, lang, setLang, setCmdOpen, mobileNav, setMobileNav, aiAvail, setAiOpen, notifs, unread }) => {
  const nav = useNavigate();
  return (
    <header className="h-16 sticky top-0 z-30 glass border-b border-slate-200/60 flex items-center gap-3 px-4 sm:px-6">
      <button className="md:hidden p-2 -ms-2 rounded-lg hover:bg-slate-100 press" onClick={() => setMobileNav(!mobileNav)} data-testid="mobile-nav-toggle"><List size={20} /></button>
      <button data-testid="command-palette-trigger" onClick={() => setCmdOpen(true)}
        className="hidden sm:flex items-center gap-2 border border-slate-200 bg-white rounded-md px-3 py-1.5 text-sm text-slate-400 hover:border-slate-400 transition-colors flex-1 max-w-sm">
        <MagnifyingGlass size={15} /> {t('Search students, apps...')} <kbd className="ml-auto font-mono-label text-[10px] hidden sm:inline">⌘K</kbd>
      </button>
      <button data-testid="command-palette-trigger-mobile" onClick={() => setCmdOpen(true)} className="sm:hidden p-2 rounded-md hover:bg-slate-100"><MagnifyingGlass size={19} /></button>
      <div className="ml-auto flex items-center gap-2">
        <HelpButton />
        <div className="flex border border-slate-200 rounded-md overflow-hidden" data-testid="lang-switcher">
          {[['en', 'EN'], ['hi', 'हिं'], ['ar', 'ع']].map(([code, label]) => (
            <button key={code} data-testid={`lang-${code}`} onClick={() => setLang(code)}
              className={`px-2.5 py-1.5 text-xs font-medium transition-colors ${lang === code ? 'bg-slate-900 text-white' : 'bg-white text-slate-500 hover:text-slate-900'}`}>{label}</button>
          ))}
        </div>
        {aiAvail?.available && (
          <button data-testid="ai-assistant-trigger" onClick={() => setAiOpen(true)}
            className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-500 text-white rounded-md px-2.5 sm:px-3 py-1.5 text-sm font-medium transition-colors active:scale-[0.98]">
            <Sparkle size={15} weight="fill" /> <span className="hidden sm:inline">{t('Assistant')}</span>
          </button>
        )}
        <Popover>
          <PopoverTrigger asChild>
            <button data-testid="notifications-trigger" className="relative p-2 rounded-md hover:bg-slate-100 transition-colors">
              <Bell size={19} />
              {unread > 0 && <span className="absolute -top-0.5 -right-0.5 bg-rose-600 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center">{unread}</span>}
            </button>
          </PopoverTrigger>
          <PopoverContent align="end" className="w-96 p-0">
            <div className="flex items-center justify-between p-3 border-b border-slate-100">
              <span className="font-display font-semibold text-sm">{t('Notifications')}</span>
              <span className="flex items-center gap-3">
                <button data-testid="notif-view-all-link" className="text-xs text-orange-700 underline" onClick={() => nav('/notifications')}>View all</button>
                <button className="text-xs text-blue-600" onClick={() => api.post('/notifications/read-all')}>{t('Mark all read')}</button>
              </span>
            </div>
            <div className="max-h-80 overflow-auto" data-testid="notifications-list">
              {(notifs || []).length === 0 && <p className="p-4 text-sm text-slate-400">No notifications</p>}
              {(notifs || []).slice(0, 15).map((n) => (
                <div key={n.id} className={`p-3 border-b border-slate-50 ${!n.read ? 'bg-blue-50/50' : ''}`}>
                  <p className="text-sm font-medium">{n.title}</p>
                  <p className="text-xs text-slate-500">{n.body}</p>
                </div>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </header>
  );
};
